import { takeLatest, call, put } from 'redux-saga/effects'
import { editSupervisors } from 'api/administration/participant/editSupervisors'
import I18n from 'i18n'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import * as fromActions from '../../actions/user.action'
import * as fromParticipantsActions from '../../actions/participants.action'

async function updateSupervisor({ userId, supervisors }: any) {
  return editSupervisors(userId, supervisors)
}

function* participantEditSupervisorEffectSaga(
  action: fromActions.UpdateUserSupervisorsAction
) {
  const { userId, supervisors, onSuccess, onError } = action.payload
  try {
    const data = yield call(updateSupervisor, {
      userId,
      supervisors,
    })
    yield put(fromActions.Actions.updateUserSupervisorsSuccess(data))
    yield put(
      fromParticipantsActions.Actions.participantEditSupervisorsSuccess(data)
    )
    onSuccess?.(data)
    SuccessToast(I18n.t('administration.toastMessages.supervisorsEditSuccess'))
  } catch (error) {
    ErrorToast(I18n.t(`administration.toastMessages.genericError`))
    console.log('error: ', error)
    onError?.(error)
  }
}

export function* participantEditSupervisorWatcherSaga() {
  yield takeLatest(
    fromActions.UPDATE_USER_SUPERVISORS,
    participantEditSupervisorEffectSaga
  )
}
